import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import Header from './Header';
import Footer from './Footer';
import styles from './PagesStyle/Page1Styles';
import { isVisible } from '@testing-library/user-event/dist/utils';


const formatMoney = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return 'N/A';
  }
  
  // Convert to a number and check if there are any non-zero decimals
  const number = Number(cost);
  const hasDecimals = number % 1 !== 0;

  return hasDecimals
    ? `$${number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : `$${number.toLocaleString('en-US')}`;
};

const formatMoneyNoDecimals = (cost) => {
    if (cost === null || cost === undefined || isNaN(cost)) {
      return 'N/A';
    }
    return `$${Number(cost).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

const Page3 = ({ formData, companyLogo }) => (
  <Page size="LETTER" style={styles.pagePage3}>
    <Header formData={formData}  companyLogo={companyLogo} />



    <View style={styles.parentContainerPage3}>
      {/* Left Column */}
      <View style={styles.leftContainerPage3}>
        <View style={styles.leftColumnPage3}>
          <Text style={styles.sectionHeaderPage3}>THIRD PARTY VALUATION DATA</Text>
          <View style={styles.TitleBottomBorderPage3} />
          <View style={[styles.rowContainerPage3, { top: 5 }]}>
            {formData.uploadBlackBook ? (
              <Image
                style={styles.GeneratedImagePage3}
                src={formData.uploadBlackBook}
                onError={(error) => console.error('Error rendering image in PDF:', error)}
              />
            ) : (
              <Text style={styles.noImageTextPage3}>No image uploaded.</Text>
            )}
          </View>
        </View>
        

        <Text style={styles.sectionHeaderTwoPage3}>MARKET VALUE ANALYSIS</Text>
        <View style={styles.TitleBottomBorderTwoPage3} />
        <View style={styles.tableContainerPage3}>
          <View style={{bottom: 5}}>

            <View style={styles.greyContainer1Page3} />


            <View style={styles.greyContainer2Page3} />
            <View style={styles.greyContainer3Page3} />


            <View style={styles.greyContainer4Page3} />
            <View style={styles.greyContainer5Page3} />
            <View style={styles.greyContainer6Page3} />
            {/* Initial Values Header Row */}
            
            <View style={[styles.headerRowPage3, styles.highlightedHeaderPage3]}>
              <Text style={styles.headerTextPage3}>INITIAL VALUES</Text>
              <Text style={[styles.headerTextPage3, {left: 45}]}>HIGH</Text>
              <Text style={[styles.headerTextPage3, {left: 45}]}>LOW</Text>
            </View>
            
            {/* FMV Row */}
            <View style={styles.rowPage3}>
              <Text style={[styles.fixedCellPage3]}>FMV</Text>
              <Text style={[styles.cellPage3, {left: 9}]}>{formatMoneyNoDecimals(formData.fmv_high) || '$N/A'}</Text>
              <Text style={[styles.cellPage3, {right: 8}]}>{formatMoneyNoDecimals(formData.fmv_low) || '$N/A'}</Text>
            </View>
            
            {/* Value Adjustments Header Row */}
            <View style={[styles.headerRowPage3, styles.highlightedHeaderPage3]}>
              <Text style={styles.headerTextPage3}>VALUE ADJUSTMENTS</Text>
            </View>
            
            {/* Adjustment Rows */}
            <View style={styles.rowPage3}>
              <Text style={styles.fixedCellPage3}>A</Text>
              <Text style={[styles.fixedCellPage3]}>{formData.a_type || 'N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 32 }]}>{formatMoneyNoDecimals(Math.abs(formData.a_high)) || '$N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 76 }]}>{formatMoneyNoDecimals(Math.abs(formData.a_low)) || '$N/A'}</Text>
              <Text style={styles.wideCellPage3}></Text>
            </View>

            <View style={styles.rowPage3}>
              <Text style={styles.fixedCellPage3}>B</Text>
              <Text style={styles.fixedCellPage3}>{formData.b_type || 'N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 32 }]}>{formatMoneyNoDecimals(Math.abs(formData.b_high)) || '$N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 76 }]}>{formatMoneyNoDecimals(Math.abs(formData.b_low)) || '$N/A'}</Text>
              <Text style={styles.wideCellPage3}></Text>
            </View>

            <View style={styles.rowPage3}>
              <Text style={styles.fixedCellPage3}>C</Text>
              <Text style={styles.fixedCellPage3}>{formData.c_type || 'N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 32 }]}>{formatMoneyNoDecimals(Math.abs(formData.c_high)) || '$N/A'}</Text>
              <Text style={[styles.cellPage3, { left: 76 }]}>{formatMoneyNoDecimals(Math.abs(formData.c_low)) || '$N/A'}</Text>
              <Text style={styles.wideCellPage3}></Text>
            </View>
                      
            {/* Final Values Header */}
            <View style={[styles.headerRowPage3, styles.highlightedHeaderPage3]}>
              <Text style={styles.headerTextPage3}>FINAL VALUES</Text>
            </View>
            
            {/* Final Values Row */}
            <View style={styles.rowPage3}>
              <Text style={[styles.cellPage3, {left: 116}]}>{formatMoneyNoDecimals(formData.final_high) || '$N/A'}</Text>
              <Text style={[styles.cellPage3, {right: 7,}]}>{formatMoneyNoDecimals(formData.final_low) || '$N/A'}</Text>
            </View>
            
            {/* Maximum Loss Range */}
            <View style={[styles.headerRowPage3, styles.highlightedHeaderPage3]}>
              <Text style={styles.headerTextPage3}>MAXIMUM LOSS RANGE</Text>
            </View>
            <View style={styles.rowPage3}>
              <Text style={[styles.cellPage3, {left: 207, top: 1}]}>{formatMoneyNoDecimals(formData.max_loss) || '$N/A'}</Text>
            </View>
            <View style={styles.rowPage3}>
              <Text style={[styles.cellPage3, {left: 207, top: 2}]}>{Math.ceil(formData.max_loss_percentage)}%</Text>
            </View>
            
            {/* Total Loss Threshold */}
            <View style={[styles.headerRowPage3, styles.highlightedHeaderPage3]}>
              <Text style={styles.headerTextPage3}>TOTAL LOSS THRESHOLD</Text>
            </View>
            <View style={styles.rowPage3}>
              <Text style={styles.cellPage3}></Text>
              <Text style={[styles.cellPage3, {right: 6}]}>{formatMoneyNoDecimals(formData.loss_thresold) || '$N/A'}</Text>
            </View>
          </View>
        </View>


      </View>


      {/* Right Column */}
      <View style={styles.rightContainerPage3}>
        <View style={styles.rightColumnPage3}>
          <Text style={styles.rightHeaderPage3}>DATA PROVIDER: BLACK BOOK {'\n'}{'\n'}{'\n'}</Text>
          <Text style={styles.paragraphPage3}>
            We established this vehicle's market value after consulting{'\n'}
            with the data source cited above. The information obtained{'\n'}
            from this outside source was considered reasonably{'\n'}
            credible and trustworthy at the time of the appraisal.
            {'\n'}{'\n'}{'\n'}
          </Text>
          <Text style={styles.paragraphPage3}>
            A snapshot of the valuation source is located to the left.
            {'\n'}{'\n'}{'\n'}
          </Text>
          <Text style={styles.paragraphPage3}>
            ERROR RATE: +/-3% to +/-5%
            {'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}
            {'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}
            {'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}{'\n'}
          </Text>
        </View>


        <View style={{top: 50}}>      
          <View style={styles.rightColumnPage3}>
            <Text style={styles.paragraphPage3}>
              The high and low data points as reported by a third party{'\n'}provider.
            </Text>
          </View>

          <View style={[styles.rightColumnPage3, {marginTop: 6}]}>
            <Text style={styles.paragraphPage3}>
              Adjustments unique to this vehicle including but not limited{'\n'}to mileage, condition, and equipment.
            </Text>
          </View>

          <View style={[styles.rightColumnPage3, {marginTop: 6}]}>
            <Text style={styles.paragraphPage3}>
              The high and low data points after applying value{'\n'}adjustments.
            </Text>
          </View>

          <View style={[styles.rightColumnPage3, {marginTop: 5}]}>
            <Text style={styles.paragraphPage3}>
              The most this vehicle can possibly lose in value at the most{'\n'}severe of accidents.
            </Text>
          </View>

          <View style={[styles.rightColumnPage3, {marginTop: 4}]}>
            <Text style={styles.paragraphPage3}>
              The damage amount needed for the vehicle to no longer be{'\n'}a good candidate for repair and written off as a total loss.
            </Text>
          </View>
        </View>

        <View style={[styles.signsContainer]}>
          <Text style={[styles.cellPage3]}>{(formData.a_sign)}</Text>
          <Text style={[styles.cellPage3]}>{(formData.b_sign)}</Text>
          <Text style={[styles.cellPage3]}>{(formData.c_sign)}</Text>
        </View>



      </View>


    </View>

    <Footer />
  </Page>
);

export default Page3;